import { render, staticRenderFns } from "./SelectTemplateComponent.vue?vue&type=template&id=4c489f5d&scoped=true&"
import script from "./SelectTemplateComponent.vue?vue&type=script&lang=js&"
export * from "./SelectTemplateComponent.vue?vue&type=script&lang=js&"
import style0 from "./SelectTemplateComponent.vue?vue&type=style&index=0&id=4c489f5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c489f5d",
  null
  
)

export default component.exports